const SCOPE = 'borrower-information';

export const BorrowerInformationTestIds = {
  LOAN_NUMBER_BUTTON: `${SCOPE}.loan-number-button`,
  PHONE_NUMBER_TEXT: `${SCOPE}.phone-number-text`,
};
